export default __webpack_public_path__ + "e26f20fd9beec505219fe41dcc9e88cb.svg";